// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateArgentineDocument } from './argentine-document';
import { validateArgentinePhoneNumber } from './argentine-phone-number';
import { validateArgentineZipcode } from './argentine-zipcode';
import { validateArgentineState } from './argentine-state';
import { validateArgentineCity } from './argentine-city';
import { validateArgentineAddress } from './argentine-address';
import { validateArgentineStreetNumber } from './argentine-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { validateArgentineDocumentType} from  './argentine-document-type';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'argentineDocument':
      return onlyWhen('field_argentine_document') && validateArgentineDocument(userInputValue, userInputValues['argentineDocumentType']);

    case 'argentinePhoneNumber':
      return onlyWhen('field_argentine_phone_number') && validateArgentinePhoneNumber(userInputValue);

    case 'argentineZipcode':
      return onlyWhen('field_argentine_zipcode') && validateArgentineZipcode(userInputValue);

    case 'argentineState':
      return onlyWhen('field_argentine_state') && validateArgentineState(userInputValue);

    case 'argentineCity':
      return onlyWhen('field_argentine_city') && validateArgentineCity(userInputValue);

    case 'argentineAddress':
      return onlyWhen('field_argentine_address') && validateArgentineAddress(userInputValue);

    case 'argentineStreetNumber':
      return onlyWhen('field_argentine_street_number') && validateArgentineStreetNumber(userInputValue);

    case 'argentineDocumentType':
      return onlyWhen('field_argentine_document_type') && validateArgentineDocumentType(userInputValue);

    default:
      return VALID;
  }
}
